import { useEffect } from "react";
import { applyPageMeta, resolvePageLocale } from "constants/pageMeta";

export function usePageMeta(lang: string | null) {
  useEffect(() => {
    applyPageMeta(resolvePageLocale(lang));
  }, [lang]);
}
